<style lang="scss" scoped>
  #css-editor-form {
    ::v-deep .CodeMirror.cm-s-default.CodeMirror-wrap {
      border-radius: 5px;
    }
  }
</style>

<template>
  <div>
    <a
      class="tab-link"
      href="#"
      @click="openModal()"
    >
      <IconCss class="mx-auto" /></a>
    <BModal
      id="modal-page-css-editor"
      modal-class="modal-no-header-no-footer modal-width-850"
      size="lg"
      ref="modal-page-css-editor"
      hide-header="hide-header"
      hide-footer="hide-footer"
    >
      <template slot="default">
        <button
          class="close"
          type="button"
          aria-label="Close"
          @click="$refs['modal-page-css-editor'].hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title align-items-center text-center">
          {{ __('Editor de CSS') }}
        </h4>
        <form
          class="px-20px"
          id="css-editor-form"
          method="post"
          @submit.prevent="save()"
        >
          <div class="row ml-n30px">
            <div class="col-12">
              <div class="form-group">
                <Codemirror
                  ref="css-code-editor"
                  v-model="newCSS"
                  :options="codemirror.options"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="row text-center">
                <div class="col-12">
                  <button
                    class="btn btn-primary f-w-500"
                    type="submit"
                    :disabled="saving"
                  >
                    <i
                      class="fa fa-circle-o-notch fa-spin"
                      v-if="saving"
                    /><span v-else>{{ __('Salvar') }}</span>
                  </button>
                </div>
              </div>
              <div class="row text-center">
                <div class="col-12">
                  <button
                    class="btn btn-cancel f-w-500"
                    type="button"
                    aria-label="Close"
                    @click="$refs['modal-page-css-editor'].hide()"
                  >
                    <u>{{ __('Cancelar') }}</u>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </template>
    </BModal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import { codemirror as Codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';

// language
import 'codemirror/mode/css/css.js';

// active-line.js
import 'codemirror/addon/selection/active-line.js';
// styleSelectedText
import 'codemirror/addon/selection/mark-selection.js';
import 'codemirror/addon/search/searchcursor.js';
// highlightSelectionMatches
import 'codemirror/addon/scroll/annotatescrollbar.js';
import 'codemirror/addon/search/matchesonscrollbar.js';

import 'codemirror/addon/search/match-highlighter.js';
// keyMap
import 'codemirror/mode/clike/clike.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/comment/comment.js';
import 'codemirror/addon/dialog/dialog.js';
import 'codemirror/addon/dialog/dialog.css';

import 'codemirror/addon/search/search.js';
import 'codemirror/keymap/sublime.js';

export default {
  components: {
    BModal,
    Codemirror,
  },

  props: {
    css: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: false,
    },
  },

  data () {
    return {
      newCSS: this.css,
      saving: false,
      codemirror: {
        updating: false,
        options: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          lineWrapping: true,
          keyMap: 'sublime',
          mode: 'text/css',
          refresh: true,
        },
      },
    };
  },

  methods: {
    openModal () {
      this.$refs['modal-page-css-editor'].show();

      setTimeout(() => {
        this.$refs['css-code-editor'].codemirror.refresh();
      }, 200);
    },

    save () {
      this.saving = true;

      this.$http.put(this.url, { custom_css: this.newCSS })
        .then(({ data }) => {
          Bus.$emit('styleUpdated');

          this.saving = false;
        })
        .catch((error) => {
          Alert.error(this.__('Erro ao salvar alterações, verifique sua conexão ou tente novamente mais tarde.'));

          this.saving = false;

          console.error(error);
        });
    },
  },
};
</script>
